import { CaseStatusModel } from './caseStatusModel';

export class EditCaseStatusModel extends CaseStatusModel{
}
